export default __webpack_public_path__ + "static/media/number34-pert.71397eab.png";